<template>
  <div class="mod-order site-wrapper" v-loading="pageLoading" element-loading-text="获取中，请等待...">
    <div class="btn-control">
      <div class="tabs">
        <button :style="{color: currentTab === tab.id ? '#fff' : setBtnsColor(tab),background:currentTab === tab.id ? setBtnsBg(tab) : '#fff'}" v-for="tab of tabs" v-bind:class="['tab_button', { active: currentTab === tab.id }]"
          @click="tabChangeHdandle(tab,$event)" :key="tab.id">{{ tab.name }}</button>
      </div>
      <div class="delete">
        <el-button size="mini" v-if="delBtnShow" round @click="deleteHandle" :disabled="!dataListSelections.length">删除</el-button>
      </div>
    </div>
    <div class="lists" v-loading="listLoading">
      <el-table :data="tableData" @row-dblclick="dbRowClickHandle"
        :span-method="arraySpanMethod" @selection-change="selectionChangeHandle" style="width: 100%">
        <el-table-column type="selection" header-align="center" align="center" width="50"> </el-table-column>
        <el-table-column :label="item.label" align="center" v-for="(item, index) of tHeader" :key="`${index}-${item.post}`">
          <el-table-column :width="item.type=='button' && item.options.button && item.options.button[Object.keys(item.options.button)[0]].length>2 ? 250 : ''" :prop="item.post" align="center">
            <template slot="header" slot-scope="{}">
              <span v-if="item.type === 'input'">
                <el-input v-model="searchForm[item.post]" size="mini" clearable prefix-icon="el-icon-search"
                  @change="filterHandle" placeholder="请输入" />
              </span>
              <span slot="header" v-if="item.type === 'select'">
                <el-select v-model="searchForm[item.post]" size="mini" clearable prefix-icon="el-icon-search"
                  @change="filterHandle" placeholder="请选择">
                  <el-option :label="op.label" :value="op.code" v-for="(op, index) of item.options.valueData" :key="index"></el-option>
                </el-select>
              </span>
              <span slot="header" v-if="item.type === 'date'">
                <el-date-picker @change="filterHandle" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="searchForm[item.post]"
                  style="width: 100%">
                </el-date-picker>
              </span>
            </template>
            <template slot-scope="scope">
              <div v-if="item.type=='button' && item.options && item.options.button && item.post && scope.row[item.post] && item.options.button[scope.row[item.post]] && item.options.button[scope.row[item.post]].length">
                <el-button v-for="(btn,i) in item.options.button[scope.row[item.post]]" :key="i" :style="{'font-size': '14px','padding': '0','color':(btn.color || '#333')}" type="text" @click="btnClick(btn.code,scope.row)">{{btn.label}}</el-button>
              </div>
              <span class="ellipsis" :title="scope.row[item.post]" v-else :style="{color: getRowColor(item.post,scope.row[item.post])}">
                {{ scope.row[item.post] }}
              </span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <div class="mod-page">
        <pagination v-show="totalPage > 0" :total="totalPage" :page.sync="pageIndex" :limit.sync="pageLimt"
          @pagination="getDataList" />
      </div>
    </div>
    <resultList v-if="resultListPop" ref="resultListPop"></resultList>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import resultList from "../report/resultList.vue";
export default {
  name: "order",
  components: {
    resultList,
    Pagination
  },
  data() {
    return {
      currentTab: "",
      tabs: [],
      listLoading: false,
      pageLoading: false,
      tHeader: [],
      tableData: [],
      dataListSelections: [],
      searchForm: {},
      cellArr: [],
      cellPos:0,
      pageIndex: 1,
      pageLimt: 10,
      totalPage: 0,
      indexMerge:[],
      goodsIdKey:[],
      idKey:[],
      resultListPop:false
    };
  },
  created() {
    this.getDataList();
  },
  computed:{
    setBtnsColor(){
      return function(tab){
        if(tab.options){
          let op = JSON.parse(tab.options);
          return op.color;
        }
      }
    },
    setBtnsBg(){
      return function(tab){
        if(tab.options){
          let op = JSON.parse(tab.options);
          return op.color;
        }
      }
    },
    delBtnShow(){
      let btn = this.tabs.filter(v=>v.id == this.currentTab);
      return btn.length && btn[0].button
    },
    getRowColor(){
      return function(post,data){
        let op = this.tHeader.filter(v=>v.post == post);
        if(op.length && op[0].options && op[0].options.valueData && op[0].options.valueData.filter(v=>v.st == data).length>0){
          return op[0].options.valueData.filter(v=>v.st == data)[0].color;
        }
      }
    }
  },
  methods: {
    btnClick(btn,row){
      switch(btn){
        case "report":
          // 查看报告
          if(this.goodsIdKey.length>0 && this.goodsIdKey[0].post && row[this.goodsIdKey[0].post]){
            this.resultListPop = true;
              this.$nextTick(() => {
                this.$refs.resultListPop.init(row[this.goodsIdKey[0].post],'','order');
              });
          }
          break;
        case "delete":
        // 删除订单
        this.dataListSelections = [row];
        this.deleteHandle();
        break;
        case "detail":
          // 查看详情
          this.dbRowClickHandle(row)
        break;
        case "entrust":
          // 查看委托单
          this.pageLoading = true;
          if(this.idKey.length>0 && this.idKey[0].post){
            this.$http.post(this.$api.orderApi.myEntrustPdf,{orderId:row[this.idKey[0].post]}).then(({ data }) => { 
            this.pageLoading = false;
            if(!data.data){
                this.$message.error(data.msg)
                return
              }
              window.open(window.SITE_CONFIG["baseUrl"]+ '/checkmall-file/api/file/previewOrderPdf?fileCode='+ data.data.fileCode+'&fileName='+data.data.fileName);
            }).catch(()=>{
                this.pageLoading = false;
            }); 
          }
          break;
        case "copyOrder":
          // 再次送检
          this.$http.post(this.$api.orderApi.copyOrder, {orderId: row[this.idKey[0].post]}).then(({
						data
					}) => {
						this.$message({
							message: data.msg,
							type: "success"
						});
						this.$router.push({ name: "order-details", query: { orderId: data.data,state:'dtj'}});
					});
          break;
        case "withdraw":
          // 撤回订单
          this.$http.post(this.$api.orderApi.withdraw, {orderId: row[this.idKey[0].post]}).then(({
						data
					}) => {
						this.$message({
							message: data.msg,
							type: "success"
						});
						this.pageIndex = 1;
            this.getDataList();
					});
          break;
      }
    },
    getDataList() {
      this.listLoading = true;
      let params = {
        current: this.pageIndex,
        size: this.pageLimt,
        data: {
          ...this.searchForm,
          state: this.currentTab
        }
      };
      this.$http.post(this.$api.orderApi.orderIndex, params).then(({ data }) => {
        this.listLoading = false;
        this.tabs = data.data;
        if (!this.currentTab) {
          this.currentTab = data.data.filter(v => v.name == '全部')[0].id;
        }
        let obj = data.data.filter(v => v.id === this.currentTab)[0].map;
        this.tableData = (obj && obj.list) || [];
        this.totalPage = (obj && obj.total) || 0;
        this.tHeader = (obj && obj.tHeader.filter(v => {
          return v.showed == true;
        })) || [];
        // 保存样品id的key,大列表查看报告需要
        this.goodsIdKey = obj && obj.tHeader.filter(v => {
          return v.fieldKey == "goodsId"
        });
        // 保存订单id,大列表查看委托单需要
        this.idKey = obj && obj.tHeader.filter(v =>v.fieldKey == "id");
        this.$nextTick(() => {
          // 表格合并
          this.indexMerge = [];
          this.tHeader.forEach((v,i) => {
            if(v.options && v.options.isMerge && v.options.isMerge == true){
              // 需要合并的列序号
              this.indexMerge.push(i+1);
            }
          })
          this.merage();
        })
      }).catch(()=>{
				this.listLoading = false;
			});
    },
    // 合并订单号
    arraySpanMethod({ rowIndex, columnIndex }) {
      // 第一列
      if (this.indexMerge.includes(columnIndex)) {
        const _row = this.cellArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    merage() {
      this.cellArr = [];
      this.cellPos = 0;
      for (var i = 0; i < this.tableData.length; i++) {
        if (i === 0) {
          this.cellArr.push(1);
          this.cellPos = 0;
        } else {
          if (this.tableData[i]['order.id'] === this.tableData[i - 1]['order.id']) {
            this.cellArr[this.cellPos] += 1;
            this.cellArr.push(0);
          } else {
            this.cellArr.push(1);
            this.cellPos = i;
          }
        }
      }
    },
    // 双击行详情
    dbRowClickHandle(row) {
      let currName = row['order.st'],st='';
      switch (currName) {
					case '1':
						st = 'dtj';
						break;
            case '4':
						st = 'xxfh';
						break;
            case '3':
						st = 'shsb';
						break;
            case '2':
						st = 'dsh';
						break;
            case '5':
						st = 'dsy';
						break;
            case '6':
						st = 'jyz';
						break;
            case '7':
						st = 'dzf';
						break;
            case '8':
						st = 'ywc';
						break;
				}
      this.$router.push({ name: "order-details", query: { orderId: row['order.id'],state:st}});
    },
    filterHandle() {
      this.pageIndex = 1;
      this.getDataList();
    },
    tabChangeHdandle(tab,e) {
      if(tab.options){
        e.target.style.background = JSON.parse(tab.options).color;
        e.target.style.color="#fff";
      }
      this.tabs.forEach(v=>{
        if(v.id != tab.id){
          this.setBtnsColor(v);
        }
      })
      this.$forceUpdate();
      this.currentTab = tab.id;
      this.dataListSelections = [];
      this.getDataList();
    },
    // 删除
    deleteHandle() {
      this.$confirm(`确定进行["删除"]操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          orderIds: this.dataListSelections.map((item) => {
            return item['order.id'];
          }),
        };
        this.$http.post(this.$api.orderApi.orderDel, params).then(({ data }) => {
          this.$message({
            message: data.msg,
            type: "success"
          });
          this.pageIndex = 1;
          this.getDataList();
        });
      });

    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
  }
};
</script>

<style lang="scss" scoped>
.mod-order {
  .btn-control {
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .delete {
      button {
        font-size: 16px;
        font-weight: bold;
        color: #FF6F77;
        width: 80px;
        height: 32px;
        border-radius: 24px;
        border: 1px solid #F0F0F0;
      }
    }
  }

  .lists {
    margin-bottom: 64px;
    min-height: 581px;
    background: #fff;
    padding: 24px;
  }
}
</style>
